export { SearchParams } from '@flowus/login/const';
export { $searchParams } from '@flowus/common/flowus-utils/search-params';
export { Regex } from '@flowus/common/url';
export { ViewPath } from '@flowus/common/static-const';

export const toPercent = (num: number, total: number) =>
  Math.max(Math.round((num / total) * 10000) / 100, 0);
